/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import './style/paymentMethod.scss';

import {AwesomeIcon, CloseButton, Loader, WithBackground} from '@dvrd/dvr-controls';
import React, {MouseEventHandler} from 'react';
import Sepa from "../../misc/sepa";
import Ideal from "../../misc/ideal";
import Mastercard from '../../misc/mastercard';
import Stripe from '../../misc/stripe';

interface Props {
    onChoose: (paymentMethod: 'ideal' | 'cc' | 'sepa') => MouseEventHandler;
    onClose: MouseEventHandler;
    active: boolean;
    loading: boolean;
    activeUsersEstimate: number;
}

export default function PaymentMethod(props: Props) {
    const {active, onChoose, onClose, loading, activeUsersEstimate} = props;

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='payment-method'>
                <div className='header-container'>
                    <label className='header-title'>Abonnement starten</label>
                    <CloseButton onClick={onClose}/>
                </div>
                <div className='body-container'>
                    <div>
                        <label className='message'>Welke betaalmethode wil je aan je account koppelen?</label>
                        <label className='disclaimer'>Betaling verloopt altijd middels een automatische incasso</label>
                    </div>
                    <div className='buttons'>
                        <Loader active={loading}/>
                        <div className='method ideal' onClick={onChoose('ideal')}>
                            <Ideal width='3rem' height='3rem'/>
                            <label className='type-label'>iDeal</label>
                        </div>
                        <div className='method' onClick={onChoose('sepa')}>
                            <Sepa width='3rem' height='3rem'/>
                            <label className='type-label'>SEPA</label>
                        </div>
                        <div className='method' onClick={onChoose('cc')}>
                            <Mastercard width='3rem' height='3rem'/>
                            <label className='type-label'>Creditcard</label>
                        </div>
                    </div>
                    <div className='bottom-container'>
                        <div className='checkout-signals-container'>
                            <AwesomeIcon name='check' prefix='fas' className='check-icon'/>
                            <label>Meer dan <b>{activeUsersEstimate}</b> actieve gebruikers</label>
                            <AwesomeIcon name='check' prefix='fas' className='check-icon'/>
                            <label><b>4.9</b> uit 5 sterren op Google reviews</label>
                            <AwesomeIcon name='check' prefix='fas' className='check-icon'/>
                            <label><b>Miljoenen</b> succesvolle facturen verstuurd!</label>
                        </div>
                        <div className='stripe-container'>
                            <Stripe width='2rem' height='1rem'/>
                            <AwesomeIcon className='stipe-icon' name='check' prefix='fas'/>
                            <label className='stripe-text'>VERIFIED PARTNER</label>
                        </div>
                    </div>
                </div>
            </div>
        </WithBackground>
    )
}